<template>
  <el-dialog
    title="Nas Listesi"
    :visible="Modal"
    center
    width="50%">
    <a @click="$emit('ModalOlayi', false)" class="ModalKapat"><i class="el-icon-close"></i></a>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="Nas Listesi" name="1">
        <table class="table table-sm">
          <thead>
          <tr>
            <th>IP Adresi</th>
            <th>Mikrotik Adı</th>
            <th>Port</th>
            <th>Secret</th>
            <th>Kullanıcı Adı</th>
            <th>Parola</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="n in NasListe">
            <td>{{n.nasname}}</td>
            <td>{{n.shortname}}</td>
            <td>{{n.ports}}</td>
            <td>{{n.secret}}</td>
            <td>{{n.nKadi}}</td>
            <td>{{n.nPass}}</td>
            <td width="50">
              <el-tooltip class="item" effect="dark" content="Nas Düzenle"
                          placement="top-start">
                <a href="#" @click="Duzenle(n)" class="text-info mr-1"> <i class="feather-edit-2"></i></a>
              </el-tooltip>
              <el-tooltip class="item" effect="dark"
                          content="Nas Sil"
                          placement="top-start">
                <a href="#" @click="SilOnay(n.id,n.Bina_id)" class="text-danger"> <i
                  class="el-icon-delete-solid"></i></a>
              </el-tooltip>

            </td>
          </tr>
          </tbody>
        </table>
      </el-collapse-item>
      <el-collapse-item :title="NasText" name="2">
        <el-form :model="Form" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item label="IP Adresi" prop="nasname">
                <el-input v-model="Form.nasname"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="Mikrotik Adı" prop="shortname">
                <el-input v-model="Form.shortname"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Port" prop="ports">
                <el-input v-model="Form.ports"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Secret" prop="secret">
                <el-input v-model="Form.secret"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Kullanıcı Adı" prop="nKadi">
                <el-input v-model="Form.nKadi"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Parola" prop="nPass">
                <el-input v-model="Form.nPass"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <hr>
        <div class="dialog-footer text-center">
          <el-button type="primary" size="medium" :disabled="lo" @click="Submit()" icon="el-icon-check">
            Kaydet
          </el-button>
          <el-button type="danger" size="small" v-if="Form.id" :disabled="lo" @click="SayfaYukle()"
                     icon="el-icon-close">
            Düzenlemeyi İptal Et
          </el-button>
        </div>
      </el-collapse-item>
    </el-collapse>


  </el-dialog>
</template>

<script>
  import Yukleniyor from "../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    props: ['Modal', 'Bina_id'],
    data() {
      return {
        activeNames: ['1'],
        lo: false,
        NasListe: null,
        NasText: 'Nas Ekle',
        Form: {
          nasname: null,
          shortname: null,
          type: 'other',
          ports: '3799',
          secret: null,
          server: null,
          community: null,
          description: null,
          nKadi: null,
          nPass: null,
          Bina_id: this.Bina_id,
          id: null
        },
        FormHata: {
          nasname: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          shortname: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          ports: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          secret: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          nKadi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          nPass: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        }
      }
    },
    methods: {
      Duzenle(data) {
        this.activeNames = ['2'];
        this.NasText = 'Nas Düzenle';
        this.Form = data;
      },
      SilOnay(id, Bina_id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id, Bina_id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id, Bina_id) {
        this.$store.dispatch("Delete", {...this.Form, path: '_radius/nas/' + id + '/' + Bina_id})
          .then(response => {
            if (response.Durum == "OK") {
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
      SayfaYukle() {
        this.activeNames = ['1'];
        this.lo = true;
        this.NasText = 'Nas Ekle';
        this.Form = {
          nasname: null,
          shortname: null,
          type: 'other',
          ports: '3799',
          secret: null,
          server: null,
          community: null,
          description: null,
          nKadi: null,
          nPass: null,
          Bina_id: this.Bina_id,
          id: null
        };
        this.$store.dispatch("Get", {path: '_radius/nas/' + this.Bina_id})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.NasListe = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Post", {
              ...this.Form,
              path: '_radius/nas/' + this.Bina_id
            })
              .then(response => {
                this.lo = false;
                if (response.Durum == "OK") {
                  this.SayfaYukle();
                  this.$message.success("Radius Bilgileri kayıt edilmiştir.");
                } else {
                  this.$message.error(response.Mesaj);
                }
              })
          }
        })
      }
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Internet/NasModal.vue